import { useState } from 'react'

import { useEffect } from 'modules/core/hooks/useEffect'

import { usePolicyPeriods } from 'modules/payroll_bundle/lib/policyPeriodsContext'
import bankAccounts from 'modules/payroll_bundle/store/collections/bankAccounts'
import paymentItems from 'modules/payroll_bundle/store/collections/paymentItems'
import payments from 'modules/payroll_bundle/store/collections/payments'
import resultsCollection from 'modules/payroll_bundle/store/collections/results'

import { usePaymentTotals } from './usePaymentTotals'

export const usePaymentsPageLoader = () => {
  const [fetching, setFetching] = useState(true)
  const { loadingPolicyPeriodCollection, currentPeriod } = usePolicyPeriods()
  const currentPeriodId = currentPeriod?.id
  const { loading: fetchingPaymentTotals } = usePaymentTotals(currentPeriodId)

  async function fetchData() {
    setFetching(true)

    try {
      if (currentPeriod) {
        const data = { policy_period_id: currentPeriodId }

        await Promise.all([
          resultsCollection.fetch({ data }),
          bankAccounts.fetch(),
          payments.fetch({ data }),
          paymentItems.fetch({ data }),
        ])
      }
    } finally {
      setFetching(false)
    }
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPeriodId])

  return {
    fetching: fetching || loadingPolicyPeriodCollection || fetchingPaymentTotals,
  }
}
